import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "plus--sprite",
  "use": "plus--sprite-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"plus--sprite\">\n    <g fill=\"none\" fill-rule=\"evenodd\" stroke=\"#1E2122\" stroke-linecap=\"square\">\n        <path d=\"M16 6.667v18.666M6.667 16h18.666\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol